import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    UPDATE_GROUP_REQUEST,
    UPDATE_GROUP_SUCCESS,
    UPDATE_GROUP_FAILURE
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateGroupAction = (groupId,dataTarget) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_FB_BOT}/api/group/${groupId}`,
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(dataTarget);
        }),
        types: [
            UPDATE_GROUP_REQUEST,
            {
                type: UPDATE_GROUP_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": UPDATE_GROUP_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: UPDATE_GROUP_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": UPDATE_GROUP_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateGroupAction}